module.exports = __webpack_public_path__ + "img/cajas.7a0864e8.png";